// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import {Settings_context} from '../settings_ctx';
import cn from 'classnames';
import styles from './highest_rated.module.less';
import {use_section_scroll} from '../lib/use_section_scroll';
import {use_swipe} from '../ui/use_swipe';
import {perr} from 'hola_pub_util';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
// @ts-ignore
import {App_context} from '../context';
import {use_translation_v} from '../lib/trans_v';
import Icon_arrow_left from '../img/svg/navig/arrow_left.svg';
import Icon_arrow_right from '../img/svg/navig/arrow_right.svg';
import {Svg} from '../shared/svg';
import {use_hover} from '../lib/use_hover';
import {use_scrolled} from '../ui_utils';
// @ts-ignore
import {get_link_review} from '../install_util.js';
import {img_url} from '../ui/img_url';


const reviews_empty = [
    {name: '', text: [''], source: 'Chrome store', source_key: 'chrome'},
    {name: '', text: [''], source: 'Chrome store', source_key: 'chrome'},
    {name: '', text: [''], source: 'Chrome store', source_key: 'chrome'},
    {name: '', text: [''], source: 'Chrome store', source_key: 'chrome'},
    {name: '', text: [''], source: 'Chrome store', source_key: 'chrome'},
    {name: '', text: [''], source: 'Chrome store', source_key: 'chrome'},
];

type t_highest_rated_mode = 'stars'|'info';
interface i_highest_rated_props {
    cls?: string;
    info_cls?: string;
    colored?: boolean;
    ladder?: boolean;
    mode?: t_highest_rated_mode;
    hide_info?: boolean;
    arrows?: boolean;
    fetch_at_once?: boolean;
    t_prefix?: string;
    trust_pilot?: boolean;
}
export const Highest_rated = (props:i_highest_rated_props)=>{
    const {cls, mode = 'stars', colored, ladder, arrows, hide_info,
        info_cls = '', fetch_at_once, t_prefix='', trust_pilot} = props;
    // @ts-ignore
    const {host} = useContext(App_context);
    const {theme} = useContext(Settings_context);
    const {t, T} = use_translation_v();
    const r = useRef<HTMLHeadingElement>();
    const [active, set_active] = useState(false);
    const scrolled = use_section_scroll(r, true, {treshold: 0.3,
        max_width: 0});
    const [active_slide, set_active_slide_] = useState(0);
    const [local_review, set_local_review]
        = useState(reviews_empty);
    const set_active_slide = value=>{
        perr({id: 'www_highest_rated_click'});
        set_active_slide_(value);
    };
    const style_vars:any = {
        '--active_slide': active_slide,
        '--count_review': local_review.length,
    };
    useEffect(()=>{
        if (active)
            return;
        if (scrolled)
            perr({id: 'www_highest_rated_show'});
        if (scrolled || fetch_at_once)
        {
            set_active(true);
            etask(function*(){
                const end = `https://${host}/cms_api/review/posts`;
                const data = yield fetch(`${end}?posts_per_page=10`);
                if (!data || !Array.isArray(data.posts))
                    return;
                set_local_review(data.posts.map(p=>{
                    const text = p.content
                        .replace('<p>', '"').replace('</p>', '"');
                    return {
                        name: p.title,
                        text: [text],
                    };
                }));
            });
        }
    }, [scrolled]);
    const on_right = ()=>set_active_slide(active_slide ? active_slide-1 : 0);
    const on_left = ()=>set_active_slide(active_slide < local_review.length-1 ?
            active_slide+1 : local_review.length-1);
    const swipe_events = use_swipe({
        on_right,
        on_left,
    });
    const [reviews_ref, reviews_hovered] = use_hover<HTMLDivElement>();
    const [info_ref, info_hovered] = use_hover<HTMLDivElement>();
    const {scrolling} = use_scrolled();
    const show_arrows = !scrolling && (reviews_hovered || info_hovered);
    const chrome_rating = '4.9';
    const info_keys = ['stars', 'downloads', 'years', 'countries'];
    return <div className={cn(styles.root, cls, mode=='info' &&
      styles.mode_info)}>
      {mode=='info' && <div className={theme.container} ref={info_ref}>
        <div></div>
        {trust_pilot && <img className={cn('lazyload', styles.trust_pilot)}
          src={img_url('hola2023/trustpilot.png')} alt="trust_pilot"/>}
        <h2 ref={r}>{t('Don\'t just take our word for it')}</h2>
        <div className={cn(styles.info, info_cls && info_cls)}
          style={hide_info ? {display: 'none'} : {}}>
          {info_keys.map(k=><div key={k}
            className={styles.info_cell}>
            <div className={cn(theme.u1, styles.info_title)}>
              {t(t_prefix+`highest_rated.info.${k}.title`)}</div>
            <div className={cn(theme.p2)}>
              {t(t_prefix+`highest_rated.info.${k}.subtitle`)}</div>
          </div>)}
        </div>
      </div>}
      {mode=='stars' && <div className={theme.container}>
        <div></div>
        <h2 className="small" ref={r}>{t('The (Almost) 5 Star Service')}</h2>
        <p>
          {t('Trusted and loved by our users')}<br/>
          <T i18nKey={t_prefix+`highest_rated.ranked.chrome`}
            components={{span: <span className={cn(theme.primary,
            theme.bold)}/>}}
            values={{rating: chrome_rating}}/>
        </p>
        <div className={cn(styles.stars, active && styles.active)}></div>
      </div>}
      <div className={cn(styles.review, styles.dynamic_review, colored &&
        styles.colored, ladder && styles.ladder)} ref={reviews_ref}
        style={style_vars} onTouchStart={swipe_events.on_touch_start}
        onTouchMove={swipe_events.on_touch_move}>
        <div className={cn(styles.reviews_position, styles.dynamic_cnt)}>
          {local_review.map((review, i)=>{
              const text_cls = cn(theme.p2, styles.review_text);
              const name_cls = cn(theme.u3, styles.review_name);
              const source = review.source || 'Chrome store';
              const source_key = review.source_key || 'chrome';
              return <div key={i} className={styles.one_review_wrapper}>
                <div className={cn(styles.one_review,
                  active_slide==i && styles.active)} onClick={()=>{
                    set_active_slide(i);
                  }}>
                  <p className={text_cls}
                    dangerouslySetInnerHTML={{__html: review.text[0]}}></p>
                  <div className={styles.review_bottom}>
                    <Fragment>
                      <p className={name_cls}>{review.name}</p>
                      <a
                        href={get_link_review(source_key)}
                        className={cn(styles.review_src, theme.u3)}>
                        {source}</a>
                    </Fragment>
                  </div>
                </div>
              </div>;
          })}
        </div>
        {arrows && <div className={cn(styles.arrows, show_arrows &&
          styles.shown)}>
          <button className={cn(styles.arrow)} onClick={on_right}>
            <Svg icon={<Icon_arrow_left width={24} height={24}/>}
            data-clickid="highest_rated_arrow"/>
          </button>
          <button className={cn(styles.arrow)} onClick={on_left}>
            <Svg icon={<Icon_arrow_right width={24} height={24}/>}
            data-clickid="highest_rated_arrow"/>
          </button>
        </div>}
      </div>
      {!arrows && <Fragment>
        <div className={cn(styles.review_switcher, styles.dynamic)}>
          {local_review.map((_r, i)=>{
              return <button key={i} type="button"
                className={cn(styles.but_sw, active_slide==i && styles.active)}
                onClick={()=>set_active_slide(i)}></button>;
          })}
        </div>
        <p className={cn(theme.xs, styles.explanation)}>*These testimonials
          were collected from Hola extension reviews on Chrome Webstore during
          the period of Sep 1, 2021 to Oct 20, 2022</p>
      </Fragment>}
    </div>;
};
